import { Filter } from 'lucide-react';
import { components, OptionProps } from 'react-select';

import { PortainerSelect, Option } from '@@/form-components/PortainerSelect';
import { Icon } from '@@/Icon';
import { InputGroup } from '@@/form-components/InputGroup';

import { CustomResourceDefinition } from '../types';

interface Props {
  crds: CustomResourceDefinition[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function CustomResourceDefinitionFilter({
  crds,
  value,
  onChange,
  placeholder = 'Select a Custom Resource Definition',
}: Props) {
  const options = crds.map((crd) => ({
    value: crd.name,
    label: crd.name,
  }));

  return (
    <InputGroup size="small">
      <InputGroup.Addon>
        <div className="flex items-center gap-1">
          <Icon icon={Filter} />
          Definition
        </div>
      </InputGroup.Addon>
      <div className="min-w-[400px]">
        <PortainerSelect
          value={value}
          onChange={(newValue) => onChange(newValue || '')}
          options={options}
          components={{
            Option: CrdOption,
          }}
          placeholder={placeholder}
          isClearable
          bindToBody
          data-cy="crd-filter"
          size="sm"
        />
      </div>
    </InputGroup>
  );
}

function CrdOption({ data, ...props }: OptionProps<Option<string>, false>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option data={data} {...props}>
      <span className="truncate" title={data.label}>
        {data.label}
      </span>
    </components.Option>
  );
}
